/**
 *  @deprecated
 * */ 
export class PaymentRestService {

    public static readonly $inject: string[] = ["$rest"];

    constructor(private $rest: qpmn.common.rest.IRestService) {

    }

    /**
     * @description 获取配送方式
     */
    public payMethod(): angular.IPromise<qpmn.common.rest.IRestResponse<any>> {
        return this.$rest.http<any>("paymentRestService", "payMethod");
    }
}